import oauthEndpoints from "./endpoints/oauth.js";
import selfEndpoints from "./endpoints/self.js";
import passwordEndpoints from "./endpoints/password.js";
const authTags = ["account", "self", "password"];
const authAPIConfig = {
  reducerPath: "authApi",
  tagTypes: authTags,
  endpoints: (builder) => ({
    ...oauthEndpoints(builder),
    ...selfEndpoints(builder),
    ...passwordEndpoints(builder)
  })
};
export {
  authAPIConfig,
  authTags,
  oauthEndpoints,
  passwordEndpoints,
  selfEndpoints
};
